import { render } from "./CheckClubcardTokenForm.vue?vue&type=template&id=1fb8869e"
import script from "./CheckClubcardTokenForm.vue?vue&type=script&lang=js"
export * from "./CheckClubcardTokenForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__